import {
    roundValue,
    toDecimal
} from "../../../../../util/decimal-utils";
import {
    getVariance,
    getUtilisationRate,
    getEffortCompletionPercentage,
    calculateActualHours,
    formatHoursDisplay
} from "../../hours-calculation";

// Helper to calculate hours for variations/options using their existing subTasks data and global subtasks
const calculateVariationHours = (variations, timesheetEntries, allSubtasks = []) => {
    return variations.map(variation => {

        // Variations may have pre-calculated forecastHours from backend,
        // or subTasks with labor data attached, or linked to global subtasks
        let forecastHours;
        const attachedSubtasks = variation.subTasks || variation.subtasks || [];
        const linkedSubtasks = allSubtasks.filter(s => s.taskId === variation.id);

        if (variation.forecastHours !== undefined && variation.forecastHours !== null) {
            forecastHours = toDecimal(variation.forecastHours);
        } else {
            forecastHours = toDecimal(0);

            // Deduplicate subtasks by id to ensure we don't double count if they are in both lists
            const variationSubtasksMap = new Map();
            [...attachedSubtasks, ...linkedSubtasks].forEach(s => {
                if (s.id && !variationSubtasksMap.has(s.id)) {
                    variationSubtasksMap.set(s.id, s);
                }
            });
            const variationSubtasks = Array.from(variationSubtasksMap.values());

            // Calculate forecast hours from subtasks labor data
            if (Array.isArray(variationSubtasks)) {
                variationSubtasks.forEach(subtask => {
                    if (subtask.labor && Array.isArray(subtask.labor)) {
                        subtask.labor.forEach(laborItem => {
                            try {
                                const laborData = typeof laborItem === 'string' ? JSON.parse(laborItem) : laborItem;
                                // Only include if is_personnel is true or undefined (Source of Truth)
                                if (laborData.is_personnel !== false && laborData.isPersonnel !== false) {
                                    const qty = laborData.qty?.value !== undefined ? laborData.qty.value : (laborData.qty || laborData.quantity || 0);
                                    forecastHours = forecastHours.plus(toDecimal(qty));
                                }
                            } catch (error) {
                                console.error('Error parsing labor data for variation:', error);
                            }
                        });
                    }
                });
            }
        }

        const totalForecastHours = forecastHours.toNumber();

        // Aggregate actual hours from all subtasks to accurately reflect total variation effort
        let totalActualHours = toDecimal(0);
        const allVarSubtasks = [...attachedSubtasks, ...linkedSubtasks];
        if (allVarSubtasks.length > 0) {
            const seenIds = new Set();
            allVarSubtasks.forEach(subtask => {
                if (subtask.id && !seenIds.has(subtask.id)) {
                    seenIds.add(subtask.id);
                    totalActualHours = totalActualHours.plus(toDecimal(calculateActualHours(subtask.id, timesheetEntries, 'TASK')));
                }
            });
        }
        // Fallback: Check for hours logged directly against the variation itself (id matches entry.taskId)
        totalActualHours = totalActualHours.plus(toDecimal(calculateActualHours(variation.id, timesheetEntries, 'TASK')));

        const actualHours = totalActualHours.toNumber();
        const variance = getVariance(actualHours, totalForecastHours);
        const utilisationRate = getUtilisationRate(actualHours, totalForecastHours);
        const effortCompletionPercentage = getEffortCompletionPercentage(actualHours, totalForecastHours);

        return {
            ...variation,
            forecastHours: totalForecastHours,
            actualHours,
            forecastHoursDisplay: formatHoursDisplay(totalForecastHours),
            actualHoursDisplay: formatHoursDisplay(actualHours),
            variance: roundValue(variance, 0),
            utilisationRate: roundValue(utilisationRate, 0),
            effortCompletionPercentageValue: effortCompletionPercentage,
            effortCompletionPercentage: `${effortCompletionPercentage.toFixed(2)}%`,
        };
    });
};

export default calculateVariationHours;